import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";

function ClienteButtons({ values, salvaCliente, getDadosCnpj }) {
  const { baseUrl } = React.useContext(AppContext);

  return (
    <div className="row justify-content-end gap-1">
      {values?.cnpj ? (
        values?.cnpj.length > 11 ? (
          <CommonButton onClick={getDadosCnpj} color="primary">
            Verificar razão social
          </CommonButton>
        ) : null
      ) : null}
      <CommonButton
        onClick={() => {
          window.location.href = baseUrl + "cliente/Cliente";
        }}
        color="danger"
      >
        Cancelar
      </CommonButton>
      <CommonButton onClick={salvaCliente} color="success">
        Salvar
      </CommonButton>
    </div>
  );
}

ClienteButtons.propTypes = {
  values: PropTypes.object.isRequired,
  salvaCliente: PropTypes.func.isRequired,
  getDadosCnpj: PropTypes.func.isRequired,
};

export default ClienteButtons;
